<template>
    <div>
        <b-row class="mb-2">
            <b-col>{{ catIndex }}.{{ itemIndex }} - {{ item.name }}</b-col>
        </b-row>
        <b-form-row>
            <b-col>
                <b-btn block squared @click="setAnswer(1)" :variant="answer === 1?'success':'secondary'"><i class="fa fa-check"></i></b-btn>
            </b-col>
            <b-col>
                <b-btn block squared @click="setAnswer(0)" :variant="answer === 0?'danger':'secondary'"><i class="fa fa-times"></i></b-btn>
            </b-col>
            <b-col>
                <b-btn block squared @click="setAnswer(-1)" :variant="answer === -1?'info':'secondary'"><i class="fa fa-ban"></i></b-btn>
            </b-col>
        </b-form-row>
        <b-row v-if="answer === 0">
            <b-col>
                <app-form-textarea-input
                    label="Explicación"
                    v-model="notes"
                    :rows="2"
                    ref="notes"
                    :autofocus="true"
                    @change="change"
                ></app-form-textarea-input>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        catIndex: {
            type: Number,
            default: 0
        },
        itemIndex: {
            type: Number,
            default: 0
        },
    },
    data: () => ({
        answer: '',
        notes: ''
    }),
    methods: {
        setAnswer(val) {
            this.answer = val;
            if(val !== 0) {
                this.notes = '';
            }
            this.change();
        },
        change() {
            this.$emit('change', {
                checklistId: this.item.id,
                valid: this.answer,
                notes: this.notes
            });
        }
    }
};
</script>